export function passwordContainsUsername(password, username) {
    const delimiters = [ '.', ',', '-', '_', '#', '@' ]
    let parts = [ username ]

    // Split by each delimiter
    delimiters.forEach(delimiter => {
        parts = parts.flatMap(part => part.split(delimiter))
    })

    // Okta policy accepts 3 consecutive letters
    parts = parts.filter(part => part.length >= 4)

    // Check if password contains parts
    for (const part of parts) {
        if (password.includes(part)) {
            return true
        }
    }

    return false
}

export const hasSequentialChars = password => {
    const chars = password.toLowerCase()

    for (let i = 0; i < chars.length - 2; i++) {
        const char1 = chars.charCodeAt(i)
        const char2 = chars.charCodeAt(i + 1)
        const char3 = chars.charCodeAt(i + 2)

        const isAscending = (char2 === char1 + 1) && (char3 === char2 + 1)
        const isDescending = (char2 === char1 - 1) && (char3 === char2 - 1)

        if (isAscending || isDescending) {
            return true
        }
    }

    return false
}

export const hasIdenticalConsecutiveChars = password => {
    for (let i = 0; i < password.length - 2; i++) {
        const char1 = password[i]
        const char2 = password[i + 1]
        const char3 = password[i + 2]

        if (char1 === char2 && char2 === char3) {
            return true
        }
    }

    return false
}
